module.exports = __webpack_public_path__ + "img/logo-sena.da3129a2.svg";